export enum PermissionRole {
  InformationTechnologyCenter = 'ศทส.',
  AssetManagementDirector = 'ผอ. กลุ่มบริหารสินทรัพย์',
  AssetManagementTeam = 'เจ้าหน้าที่กลุ่มบริหารสินทรัพย์',
  DepartmentAdmin = 'แอดมินประจำหน่วยงาน',
  DivisionDirector = 'ผอ. กอง/สำนัก/ศูนย์/สพข/สพด',
  GroupDirector = 'ผอ.กลุ่มงาน/ หน.ฝ่ายบริหาร',
  MaterialManager = 'หัวหน้าหน่วยพัสดุ',
  MaterialOfficer = 'เจ้าหน้าที่พัสดุ',
  Staff = 'เจ้าหน้าที่ปฏิบัติงานทั่วไป',
  InternalAuditGroup = 'กลุ่มตรวจสอบภายใน',
  TreasuryDivision = 'กองคลัง',
  PlanningPerformanceDivision = 'สสผ.',
  InventoryCheckingCommittee = 'กรรมการตรวจนับพัสดุ',
  CarAuditor = 'ผู้ตรวจสอบการใช้รถ',
  Driver = 'พนักงานขับรถ',
}

export enum PermissionRoleNumber {
  InformationTechnologyCenter = 1,
  AssetManagementDirector = 2,
  AssetManagementTeam = 3,
  DepartmentAdmin = 4,
  DivisionDirector = 5,
  GroupDirector = 6,
  MaterialManager = 7,
  MaterialOfficer = 8,
  Staff = 9,
  InternalAuditGroup = 10,
  TreasuryDivision = 11,
  PlanningPerformanceDivision = 12,
  InventoryCheckingCommittee = 13,
  CarAuditor = 14,
  Driver = 15,
}

export enum AuditPermissionRole {
  InventoryAuditor = 'ผู้รับผิดชอบตรวจสอบพัสดุ',
  CountingChairman = 'ประธานกรรมการ',
  AuditCommittee = 'กรรมการ',
  Chairperson = 'ประธานอนุกรรมการ',
  CommitteeMember = 'อนุกรรมการ',
}